export const WEBSITE_APP_STEPS = {
  BASIC_CONFIGURATION: 0,
  CONSENT_MANAGER: 1,
  INSTALLATION: 2,
} as const;

export const MOBILE_APP_STEPS = {
  BASIC_CONFIGURATION: 0,
  INSTALLATION: 1,
} as const;
